module.exports = __webpack_public_path__ + "static/img/scene07.425c102.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/scene07.png
// module id = Cokf
// module chunks = 1